// HomePage.jsx
import React from 'react';
import { Figure } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import UploadImage from './UploadImage';

const HomePage = () => {
  const textures = useSelector((state) => state.texture);

  return (
    <div className="home-page text-center">
      <div className="home-page-powered">
        <a href="https://ariisco.com" target="_blank">
          پردازش توسط موتور <strong>هوشمند آریس</strong>
        </a>
        <i className="bi bi-arrow-left"></i>
      </div>
      <Figure className="mt-4">
        {isEmpty(textures) ? (
          <img src="../assets/images/Eclipse-loading.gif" alt="loading" width="40" />
        ) : (
          <Figure.Image
            width={171}
            height={180}
            alt="171x180"
            src={isEmpty(textures) ? '' : textures[0][0].ticon}
          />
        )}
        <Figure.Caption className="fiqureCaption p-3">
          <b>چیدمان هوشمند {isEmpty(textures) ? '' : textures[0][0].fac}</b>
        </Figure.Caption>
      </Figure>
      <div className="container home-header d-flex text-white mx-auto">
        <div className="home-header-title">
          <div className="home-header-title-img">
            <img src="../assets/images/Frame 1484.png" alt="" />
          </div>
          <div className="home-header-title-text">
            <span>
              برای مقایسه کف پوش‌ها در محیط واقعی،عکس جدید بارگذاری کنید یا یکی از تصاویر زیر را انتخاب کنید.
            </span>
            {/* Link to the second page */}
            <Link to="/help" className="d-block">
              نحوه‌ی استفاده<i className="fa fa-long-arrow-left mx-2"></i>
            </Link>
          </div>
        </div>
      </div>
      <UploadImage />
    </div>
  );
};

export default HomePage;
